module.exports = __webpack_public_path__ + "static/media/certn_integration_ss_6.f9f3e79a.jpg";